//* Style
import HighlightedTextSectionStyle from './style';

//* Components
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';
import Image from 'components/common/Image';
import Container from 'components/common/Container';
import CustomLink from 'components/common/CustomLink';

const HighlightedTextSection = ({ first = false, section = true, slides }) => {
	return slides?.map(({ title, description, second_description, image, link }, index) => (
		<HighlightedTextSectionStyle key={index}>
			<Container
				first={first}
				section={section}
				className={'highlight-wrapper'}>
				<div className={'info-wrap'}>
					<div className={`info-content`}>
						<div className='main-content'>
							<Text className={'h6 font-soundscape-bold info-number'}>{`${index + 1}`.padStart(2, 0)}</Text>

							<Text className={'h4 font-ping-bolder info-title'}>{title}</Text>

							<Text className={'p font-ping-medium info-description'}>{description}</Text>

							{second_description && (
								<div className={'tip-wrap'}>
									<Icon
										className={'h4 info-tip-icon'}
										name={'tip'}
									/>

									<Text className={'p font-ping-bolder info-tip'}>{second_description}</Text>
								</div>
							)}

							{link && (
								<CustomLink
									url={link}
									className={`learn-more ${!!second_description ? 'has-space' : ''}`}>
									<Text
										className={'pS font-ping-bolder underline'}
										text={'learnMore'}
									/>
								</CustomLink>
							)}
						</div>
					</div>
				</div>
				<div className={'gallery-wrap'}>
					<Image
						src={image.url}
						alt={image.alt}
					/>
				</div>
			</Container>
		</HighlightedTextSectionStyle>
	));
};

export default HighlightedTextSection;
